import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { submitBooking } from '../services/api';

const BookACar = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    carType: '',
    pickupLocation: '',
    dropLocation: '',
    bookingDate: '',
    pickupTime: '',
    returnDate: '',
    notes: ''
  });
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState(null);

  // Get route parameter from URL
  const routeParam = searchParams.get('route');

  useEffect(() => {
    if (routeParam) {
      const locations = routeParam.split(' to ');
      if (locations.length === 2) {
        setFormData(prev => ({
          ...prev,
          pickupLocation: locations[0],
          dropLocation: locations[1]
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          dropLocation: routeParam
        }));
      }
    }
  }, [routeParam]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg(null);

    try {
      const result = await submitBooking(formData);
      setResponseMsg({ type: 'success', text: result.message });
      setFormData({
        name: '',
        email: '',
        phone: '',
        carType: '',
        pickupLocation: '',
        dropLocation: '',
        bookingDate: '',
        pickupTime: '',
        returnDate: '',
        notes: ''
      });
    } catch (error) {
      setResponseMsg({
        type: 'error',
        text: error.response?.data?.message || 'Something went wrong. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      {/* Page Title */}
      <div 
        className="tf-page-title mt-10" 
        style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
          padding: '80px 0'
        }}
      >
        <div className="themesflat-container full">
          <div className="page-title t-al-center">
            <span style={{ color: '#edb808', fontSize: '14px', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase' }}>
              Quick & Easy
            </span>
            <h1 className="main-title" style={{ color: 'white', fontSize: '48px', fontWeight: '700', marginTop: '10px' }}>
              Book Your Car
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', marginTop: '15px', maxWidth: '600px', margin: '15px auto 0' }}>
              Fill out the form below and our team will contact you within 30 minutes with the best rental options.
            </p>
          </div>
        </div>
      </div>

      {/* Main Booking Section */}
      <section style={{ padding: '80px 0', marginTop: '-50px', position: 'relative', zIndex: '10' }}>
        <div className="themesflat-container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {/* Booking Card */}
              <div style={{
                background: 'white',
                borderRadius: '24px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                overflow: 'hidden'
              }}>
                {/* Header */}
                <div style={{
                  background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                  padding: '40px 40px 30px',
                  textAlign: 'center'
                }}>
                  <h2 style={{ color: 'white', fontSize: '28px', fontWeight: '700', marginBottom: '10px' }}>
                    🚗 Book Your Dream Car
                  </h2>
                  <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '15px' }}>
                    Choose from our premium fleet of vehicles
                  </p>
                </div>

                {/* Form */}
                <div style={{ padding: '40px' }}>
               
                  <form onSubmit={handleSubmit}>
                    {/* Personal Info Row */}
                    <div style={{ marginBottom: '30px' }}>
                      <h4 style={{ 
                        fontSize: '16px', 
                        fontWeight: '600', 
                        color: '#1a1a2e', 
                        marginBottom: '20px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #edb808',
                        display: 'inline-block'
                      }}>
                        👤 Personal Information
                      </h4>
                      <div className="row">
                        <div className="col-lg-4 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Full Name *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter your name"
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z" stroke="currentColor" strokeWidth="1.5"/>
                                  <path d="M10 12C14.4183 12 18 13.7909 18 15V17H2V15C2 13.7909 5.58172 12 10 12Z" stroke="currentColor" strokeWidth="1.5"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Email Address *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter your email"
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.5 6.25L8.125 10.2083C9.16667 11.0417 10.8333 11.0417 11.875 10.2083L17.5 6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                  <rect x="2.5" y="4" width="15" height="12.5" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Phone Number *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Enter your phone number"
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.06667 4L5.66667 5.4C4.73333 4.6 4.53333 4.06667 4.66667 3.6C4.8 3.13333 5.66667 2.26667 6.33333 2.6L8.06667 3.13333C8.6 2.86667 9.4 2.86667 10 3.13333L10.1333 3.26667C10.6667 3.8 10.6667 5.4 10 6.33333L8.66667 7.33333C8.66667 7.33333 8.66667 8 9.13333 8.66667C9.6 9.33333 10.6667 10.6667 12 12C13.3333 13.3333 14.6667 14.4 15.3333 14.8667C16 15.3333 16.6667 15.3333 16.6667 15.3333L17.6667 14C18.6 13.0667 18.6 12.2667 18.8667 11.7333L18.6667 10H18.6667C17.8 9.33333 17.0667 8.6 16.4 7.93333C16.1333 7.66667 15.8667 7.66667 15.6 7.66667H14.6667C14.6667 7 14.6667 6.2 14.2667 5.6L12.6 3.93333C12.2667 3.6 11.5333 3.6 11.0667 4L9.66667 4.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Trip Details Row */}
                    <div style={{ marginBottom: '30px' }}>
                      <h4 style={{ 
                        fontSize: '16px', 
                        fontWeight: '600', 
                        color: '#1a1a2e', 
                        marginBottom: '20px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #edb808',
                        display: 'inline-block'
                      }}>
                        📍 Trip Details
                      </h4>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Pickup Location *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type="text"
                                name="pickupLocation"
                                value={formData.pickupLocation}
                                onChange={handleChange}
                                placeholder="Enter pickup location"
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#22c55e'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" fill="none"/>
                                  <circle cx="10" cy="10" r="3" fill="currentColor"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Drop Location *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type="text"
                                name="dropLocation"
                                value={formData.dropLocation}
                                onChange={handleChange}
                                placeholder="Enter drop location"
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#ef4444'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" strokeWidth="2" fill="none"/>
                                  <path d="M10 7V10L13 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Car & Date Row */}
                    <div style={{ marginBottom: '30px' }}>
                      <h4 style={{ 
                        fontSize: '16px', 
                        fontWeight: '600', 
                        color: '#1a1a2e', 
                        marginBottom: '20px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #edb808',
                        display: 'inline-block'
                      }}>
                        🚙 Vehicle & Schedule
                      </h4>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Select Vehicle *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <select
                                name="carType"
                                value={formData.carType}
                                onChange={handleChange}
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa',
                                  appearance: 'none',
                                  cursor: 'pointer'
                                }}
                              >
                                <option value="">Choose your vehicle</option>
                                <option value="swift-dzire">Swift Dzire </option>
                                <option value="maruti-ertiga">Maruti Ertiga</option>
                                <option value="innova-crysta">Innova Crysta</option>
                                <option value="force-urbania">Force Urbania</option>
                                <option value="tempo-traveller">Tempo Traveller</option>
                                <option value="bus-56seater">56-Seater Bus</option>
                              </select>
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#edb808'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.5 7.5H17.5L16.1716 16.3284C16.1022 16.7128 15.8364 17.0311 15.4645 17.1716C15.0926 17.3121 14.6803 17.2558 14.3568 17.0213L10.625 14.1875C10.4173 14.0214 10.25 13.7806 10.1563 13.5H9.84375C9.75003 13.7806 9.58266 14.0214 9.375 14.1875L5.64324 17.0213C5.31966 17.2558 4.90742 17.3121 4.5355 17.1716C4.16359 17.0311 3.89779 16.7128 3.82843 16.3284L2.5 7.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                  <circle cx="6.5" cy="5.5" r="1.5" fill="currentColor"/>
                                  <circle cx="13.5" cy="5.5" r="1.5" fill="currentColor"/>
                                </svg>
                              </span>
                              <span style={{
                                position: 'absolute',
                                right: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999',
                                pointerEvents: 'none'
                              }}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Pickup Date *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type="date"
                                name="bookingDate"
                                value={formData.bookingDate}
                                onChange={handleChange}
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6.66667 2.5V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                  <path d="M13.3333 2.5V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                  <path d="M2.91667 7.91667H17.0833" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                  <rect x="2.5" y="6.66667" width="15" height="11.6667" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                  <path d="M2.5 10H17.5" stroke="currentColor" strokeWidth="1.5"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Pickup Time *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type="time"
                                name="pickupTime"
                                value={formData.pickupTime}
                                onChange={handleChange}
                                required
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/>
                                  <path d="M10 5V10L13 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Notes Row */}
                    <div style={{ marginBottom: '30px' }}>
                      <h4 style={{ 
                        fontSize: '16px', 
                        fontWeight: '600', 
                        color: '#1a1a2e', 
                        marginBottom: '20px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #edb808',
                        display: 'inline-block'
                      }}>
                        📝 Additional Information
                      </h4>
                      <div className="row">
                        <div className="col-lg-12 mb-20">
                          <div style={{ position: 'relative' }}>
                            <label style={{
                              display: 'block',
                              marginBottom: '8px',
                              fontWeight: '500',
                              color: '#1a1a2e',
                              fontSize: '14px'
                            }}>
                              Special Requests / Notes
                            </label>
                            <div style={{ position: 'relative' }}>
                              <textarea
                                name="notes"
                                value={formData.notes}
                                onChange={handleChange}
                                rows="4"
                                placeholder="Enter your notes or special requests"
                                style={{
                                  width: '100%',
                                  padding: '14px 15px 14px 50px',
                                  border: '2px solid #e8e8e8',
                                  borderRadius: '12px',
                                  fontSize: '15px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa',
                                  resize: 'vertical',
                                  fontFamily: 'inherit'
                                }}
                              ></textarea>
                              <span style={{
                                position: 'absolute',
                                left: '18px',
                                top: '20px',
                                color: '#999'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.5 4.16667H17.5C17.9167 4.16667 18.3333 4.25 18.75 4.41667L10 13.3333L1.25 4.41667C1.66667 4.25 2.08333 4.16667 2.5 4.16667Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="row">
                      <div className="col-lg-12">
                        <button
                          type="submit"
                          disabled={loading}
                          style={{
                            width: '100%',
                            padding: '18px 40px',
                            background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                            color: '#1a1a2e',
                            border: 'none',
                            borderRadius: '50px',
                            fontSize: '18px',
                            fontWeight: '600',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.7 : 1,
                            transition: 'all 0.3s ease',
                            boxShadow: '0 10px 30px rgba(237, 184, 8, 0.3)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '12px'
                          }}
                        >
                          {loading ? (
                            <>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ animation: 'spin 1s linear infinite' }}>
                                <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
                                <path d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            <>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 12L8.125 17.2083C8.75 17.7917 9.58333 17.7917 10.4167 17.2083L21.5 8.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M10.8333 2.08333H17.5C17.9167 2.08333 18.3333 2.16667 18.75 2.33333" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                              </svg>
                              Submit Booking Request
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>

                     {responseMsg && (
                    <div style={{
                      padding: '15px 20px',
                      marginTop: '25px',
                      borderRadius: '12px',
                      backgroundColor: responseMsg.type === 'success' ? '#d4edda' : '#f8d7da',
                      color: responseMsg.type === 'success' ? '#155724' : '#721c24',
                      border: `1px solid ${responseMsg.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {responseMsg.type === 'success' ? (
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                        ) : (
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
                        )}
                      </svg>
                      {responseMsg.text}
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Book with Us */}
      <section style={{ padding: '80px 0', background: '#f8f9fa' }}>
        <div className="themesflat-container">
          <div className="heading-section t-al-center mb-50">
            <span style={{ color: '#edb808', fontSize: '14px', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase', display: 'block', marginBottom: '10px' }}>
              Our Benefits
            </span>
            <h2 style={{ fontSize: '36px', fontWeight: '700', color: '#1a1a2e' }}>
              Why Book With Cab Experience?
            </h2>
          </div>
          <div className="row">
            {[
              { icon: '🛡️', title: 'Fully Insured', desc: 'All our vehicles are fully insured for your peace of mind' },
              { icon: '💰', title: 'Best Prices', desc: 'Competitive rates with no hidden charges or surprise fees' },
              { icon: '👨‍✈️', title: 'Professional Drivers', desc: 'Experienced, courteous drivers with excellent knowledge' },
              { icon: '🔧', title: 'Well Maintained', desc: 'Regularly serviced vehicles ensuring safety and comfort' }
            ].map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6 mb-30">
                <div style={{
                  background: 'white',
                  padding: '35px 25px',
                  borderRadius: '16px',
                  textAlign: 'center',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.05)',
                  transition: 'transform 0.3s ease',
                  height: '100%'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div style={{
                    fontSize: '48px',
                    marginBottom: '20px'
                  }}>
                    {item.icon}
                  </div>
                  <h4 style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a2e', marginBottom: '12px' }}>
                    {item.title}
                  </h4>
                  <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.7' }}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section style={{ padding: '80px 0', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)' }}>
        <div className="themesflat-container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 style={{ fontSize: '36px', fontWeight: '700', color: 'white', marginBottom: '20px' }}>
                Need Assistance?
              </h2>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', marginBottom: '30px' }}>
                Our team is available 24/7 to help you with your booking
              </p>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a 
                  href="tel:+917801904444"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '16px 32px',
                    background: '#edb808',
                    color: '#1a1a2e',
                    textDecoration: 'none',
                    borderRadius: '50px',
                    fontWeight: '600',
                    fontSize: '16px',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.06667 4L5.66667 5.4C4.73333 4.6 4.53333 4.06667 4.66667 3.6C4.8 3.13333 5.66667 2.26667 6.33333 2.6L8.06667 3.13333C8.6 2.86667 9.4 2.86667 10 3.13333L10.1333 3.26667C10.6667 3.8 10.6667 5.4 10 6.33333L8.66667 7.33333C8.66667 7.33333 8.66667 8 9.13333 8.66667C9.6 9.33333 10.6667 10.6667 12 12C13.3333 13.3333 14.6667 14.4 15.3333 14.8667C16 15.3333 16.6667 15.3333 16.6667 15.3333L17.6667 14C18.6 13.0667 18.6 12.2667 18.8667 11.7333L18.6667 10H18.6667C17.8 9.33333 17.0667 8.6 16.4 7.93333C16.1333 7.66667 15.8667 7.66667 15.6 7.66667H14.6667C14.6667 7 14.6667 6.2 14.2667 5.6L12.6 3.93333C12.2667 3.6 11.5333 3.6 11.0667 4L9.66667 4.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Call: +91 7801904444
                </a>
                <Link 
                  to="/contact"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '16px 32px',
                    background: 'transparent',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '50px',
                    fontWeight: '600',
                    fontSize: '16px',
                    border: '2px solid rgba(255,255,255,0.3)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                    e.target.style.borderColor = 'white';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 6.25L8.125 10.2083C9.16667 11.0417 10.8333 11.0417 11.875 10.2083L17.5 6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <rect x="2.5" y="4" width="15" height="12.5" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                  </svg>
                  Email Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          .tf-page-title { padding: 50px 0 !important; }
          .main-title { font-size: 32px !important; }
          .tf-page-title p { font-size: 14px !important; }
          .booking-card { border-radius: 16px !important; }
          .booking-card .header { padding: 25px !important; }
          .booking-card .header h2 { font-size: 22px !important; }
          .booking-card .header p { font-size: 14px !important; }
          .booking-card form { padding: 25px !important; }
          .booking-card h4 { font-size: 15px !important; }
          .booking-card label { font-size: 13px !important; }
          .booking-card input { padding: 12px !important; font-size: 14px !important; }
          .booking-card select { padding: 12px !important; font-size: 14px !important; }
          .booking-card textarea { padding: 12px !important; font-size: 14px !important; }
          .btn-submit { padding: 14px 28px !important; font-size: 15px !important; }
          .info-cards { padding: 20px !important; }
          .info-cards h4 { font-size: 18px !important; }
          .info-cards p { font-size: 14px !important; }
        }
        @media (max-width: 480px) {
          .main-title { font-size: 26px !important; }
          .booking-card { margin: 0 10px !important; }
          .booking-card .header h2 { font-size: 20px !important; }
          .booking-card form { padding: 20px !important; }
        }
      `}</style>
    </div>
  );
};

export default BookACar;
